import { StrictMode, type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from '@rolefit/shared/react';
import { api } from './lib/api.js';
import { App } from './App.js';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

// Only wrap in the Google provider when a client ID is configured, so the app
// runs (email/password only) without Google set up.
const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
function withGoogle(children: ReactNode) {
  return googleClientId ? <GoogleOAuthProvider clientId={googleClientId}>{children}</GoogleOAuthProvider> : children;
}

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider client={api}>{withGoogle(<App />)}</AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
